<template>
  <div id="mainView"></div>
</template>

<script>
import {defineComponent} from 'vue';

// TCM 20231127
// import { module.exports } from 'config';
// TCM 20231127


export default defineComponent({
  name: "JitsiIframe",
  props: ['userData', 'appointmentHash', 'language'],
  data() {
    return {
      jitsiApp: null
    }
  },
  methods: {
    getVideoContainerSize() {
      const vc = document.querySelector('.video-container');
      return {
        height: vc.offsetHeight,
        width: vc.offsetWidth
      }
    },
    async initJitsi() {

      const jitsiToken = await this.$store.dispatch('fetchJitsiToken',
      {
        room: this.appointmentHash,
        user_id: this.userData.userId,
        name: this.userData.name,
        email: this.userData.email
      });

      console.log('jitsiToken: ', jitsiToken)

      const options = {
        roomName: this.appointmentHash,
        jwt: jitsiToken,
        width: this.getVideoContainerSize().width,
        height: this.getVideoContainerSize().height,
        parentNode: document.querySelector('#mainView'),
        userInfo: {
          email: this.userData.email,
          displayName: this.userData.name
        },
        participantId: String(this.userData.userId),
        configOverwrite: {
          p2p:
          {
            enabled: false
          },
          disableDeepLinking: true,
          defaultLanguage: this.language || 'en',
          dynamicBrandingUrl: process.env.BASE_URL + 'branding.json',
          disableInitialGUM: false,
          hideParticipantsStats: false,
          remoteVideoMenu:
              {
                disableKick: true,
                disableGrantModerator: true
              },
          prejoinPageEnabled: false,
          disable1On1Mode: false,
          doNotStoreRoom: true,
          enableWelcomePage: false,  // Disable the welcome page
          toolbarButtons: [
            'microphone',
            'camera',
            'desktop',
            'fullscreen',
            'fodeviceselection',
            'hangup',
            'chat',
            'videoquality',
            'tileview',
            'select-background',
            'sharedvideo',
            'download',
          ],
        },
        interfaceConfigOverwrite: {
          TOOLBAR_BUTTONS: [
            'microphone', 'camera', 'desktop', 'fullscreen',
            'fodeviceselection', 'hangup', 'chat', 'videoquality',
            'tileview', 'select-background', 'sharedvideo', 'download'
          ],
          SHOW_JITSI_WATERMARK: false,
          SHOW_WATERMARK_FOR_GUESTS: false,
          SHOW_BRAND_WATERMARK: false,
          BRAND_WATERMARK_LINK: ''
        }
      };

      console.log('userData: ', this.userData)
      console.log('options: ', options)
      //this.jitsiApp = new JitsiMeetExternalAPI('jitsi.uni-kl.de', options);
      this.jitsiApp = new JitsiMeetExternalAPI('jitsi1.wisevetlive.com', options);

      this.jitsiApp.addEventListener('videoConferenceLeft', () => {
        const mainView = document.querySelector('#mainView');
        mainView.style.visibility = "hidden"
        this.$store.commit('appointmentHash', '')
      })
    },
  },
  mounted() {
    this.initJitsi()
  }
})
</script>

<style scoped>

</style>
